var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"CenterBottom"}},[_c('dv-border-box-13',[_c('HeaderTitle',{attrs:{"title":"货运司机"}}),_c('CenterBottomEarch')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }